import { render, staticRenderFns } from "./GrantUserForBroadcast.vue?vue&type=template&id=695abc06&scoped=true"
import script from "./GrantUserForBroadcast.vue?vue&type=script&lang=js"
export * from "./GrantUserForBroadcast.vue?vue&type=script&lang=js"
import style0 from "./GrantUserForBroadcast.vue?vue&type=style&index=0&id=695abc06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695abc06",
  null
  
)

export default component.exports